import { PasswordKitInput } from "@/components/PasswordKit/input";
import { RootHeader } from "@/components/RootHeader";
import { cn } from "@/libs";
import { Button } from "antd-mobile";
import { CloseOutline } from "antd-mobile-icons";
import style from "./index.module.scss";
import { useSetup } from "./logic";

export const PageLinkAccount = () => {
  const logic = useSetup();

  return (
    <div className={style.pageLinkAccount}>
      <RootHeader
        className={style.header}
        title={"绑定账号"}
        right={<Button onClick={logic.cleanToken} className={style.headerRightBtn} ><CloseOutline className={style.headerRightIcon} /></Button>}
      />
      <div className={style.item}>钱包地址: {logic.userInfo.walletAddress}</div>
      <div className={style.item}>请输入资金密码以验证绑定该钱包地址</div>
      <PasswordKitInput withKeyboard withPopKeyboard onFill={text => logic.dispatch({
        type: "update-password",
        password: text
      })} />
      <Button className={cn("common-submit-button", style.confirmLink)} loading={logic.reqConfirm.loading} onClick={logic.reqConfirm.run}>
        确认绑定
      </Button>
      <div className={style.warning}>
        <span>重要提醒：</span>
        因绑定后可以自动扣款充值，所以绑定时请仔细检查并确认是本人的游戏账号才可绑定，
        <span>请勿替他人 扫码或绑定，以免造成不必要的损失。</span>
      </div>
    </div>
  );
};
